// 配置管理工具

const settingConfig = JSON.parse(localStorage.getItem("lpmConfig") || '{}')
const arraysSetting = JSON.parse(localStorage.getItem("lpmConfigArray") || '{}')
function save(){
  localStorage.setItem("lpmConfig", JSON.stringify(settingConfig))
}
function saveArray(){
  localStorage.setItem("lpmConfigArray", JSON.stringify(arraysSetting))
}
/**
 * 保存配置
 */
function put(name, value) {
  settingConfig[name] = value
  save()
}

/**
 * 读取配置
 */
function find(name, defaultValue) {
  if (settingConfig && typeof settingConfig[name] != typeof undefined) {
    return settingConfig[name]
  }
  return defaultValue
}

/**
 * 保存到数组
 */
function add(arrayName, value) {
  try {
    if(arraysSetting[arrayName]){
      if(arraysSetting[arrayName].indexOf(value) === -1){
        arraysSetting[arrayName].push(value)
        saveArray()
      }
    } else {
      arraysSetting[arrayName] = [value]
      saveArray()
    }
  } catch (e) {}
}

/**
 * 从数组中移除
 */
function remove(arrayName, value) {
  try {
    if(arraysSetting[arrayName]){
      const index = arraysSetting[arrayName].indexOf(value);
      if(index !== -1){
        arraysSetting[arrayName].splice(index, 1);
        saveArray()
      }
    }
  } catch (e) {}
}

function getArray(arrayName) {
  return arraysSetting[arrayName] || [];
}
function setArray(arrayName, arrayValue) {
  arraysSetting[arrayName] = arrayValue
  saveArray()
}

/**
 * 是否存在于数组中
 */
function contain(arrayName, value) {
  return getArray(arrayName).indexOf(value) != -1
}

const settings = {
  put: put,
  find: find,
  add: add,
  remove: remove,
  contain: contain,
  getArray: getArray,
  setArray: setArray,
}

export default settings
